import './asset-tabs.scss';

import { memo } from 'react';

export type AssetTab<TId extends string = string> = {
  id: TId;
  label: string;
  icon?: React.ReactNode;
  enabled?: boolean;
};

export type AssetTabsProps<TId extends string = string> = {
  items: AssetTab<TId>[];
  activeId: TId;
  onSelect: (id: TId) => void;
  disabled?: boolean;
  iconOnly?: boolean;
  className?: string;
};

const AssetTabsInner = <TId extends string>({
  items,
  activeId,
  onSelect,
  disabled = false,
  iconOnly = false,
  className,
}: AssetTabsProps<TId>) => (
  <div
    className={`asset-tabs${iconOnly ? ' asset-tabs--icon-only' : ''}${className ? ` ${className}` : ''}`}
    role="tablist">
    {items.map((item) => {
      const active = item.id === activeId;
      const isDisabled = disabled || item.enabled === false;
      return (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={active}
          aria-label={item.label}
          disabled={isDisabled}
          className={`asset-tabs__tab ${active ? 'asset-tabs__tab--active' : ''} asset-tabs__tab--${item.id}`}
          onClick={() => onSelect(item.id)}>
          {item.icon}
          {!iconOnly && <span className="asset-tabs__tab-label">{item.label}</span>}
          {!iconOnly && item.enabled === false && <span className="asset-tabs__tab-badge">soon</span>}
        </button>
      );
    })}
  </div>
);

export const AssetTabs = memo(AssetTabsInner) as typeof AssetTabsInner;
